import axios from "axios";

class API {
  constructor() {
    this._apiBase = "/api";
    let cfg = {
      baseURL: this._apiBase,
      timeout: 1000
    };
    this._axios = axios.create(cfg);
    let _token = getToken();
    if (_token) {
      this._setToken(_token);
    }
  }
  _setToken(token) {
    this._axios.defaults.headers["X-TOKEN"] = token;
    setToken(token);
  }
  getVersion() {
    return this._axios.get("version")
  }
  sendConfigRede(config) {
    return this._axios.post("config/rede", config, {
      timeout: 3000
    });
  }
  getConfigRede() {
    return this._axios.get("config/rede")
  }
  getSheriffs() {
    return this._axios.get("sheriff");
  }
  doLogin(formData) {
    let urlParams = new URLSearchParams(formData);
    return this._axios.post("login", urlParams.toString());
  }
  sendSensorParameter(sheriffId, sensor) {
    let sensorDTO = {
      id: sensor.id,
      type: sensor.sensorDescription,
      enabled: sensor.sensorConfiguration.enabled,
      act: sensor.sensorConfiguration.act
    };
    return this._axios.post(`sheriff/${sheriffId}/sensor`, sensorDTO, {
      timeout: 3000
    });
  }
  clearStatus(sheriffId) {
    return this._axios.post(`sheriff/${sheriffId}/clear`);
  }
  getMarshallConfig() {
    return this._axios.get("/config");
  }
  addSheriff(sheriffId) {
    return this._axios.post("/config", sheriffId);
  }
  deleteSheriff(sheriffId) {
    return this._axios.post("/config/delete", sheriffId);
  }
  doLogout() {
    this._setToken(null);
  }
}

function setToken(tok) {
  sessionStorage.setItem("tokenId", tok);
}

function getToken(tok) {
  return sessionStorage.getItem("tokenId", tok);
}

export {
  setToken
};
export default API;